import type { ActivityType } from '../../../typings'
import type { State } from '../../typings'

export const activityTypeUpdatedProducer = (
  state: State,
  payload?: ActivityType,
): State => {
  const activityTypes = state.activityTypes.map((activity) =>
    payload && activity.id === payload.id ? payload : activity,
  )

  return {
    ...state,
    isOpen: false,
    current: payload ? payload : state.current,
    activityTypes,
  }
}
